export namespace HistoryMode {
  export type HistoryMode =
    'OHNE_HIST' |
    'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' |
    'MIT_HIST';
  export const HistoryMode = {
    OHNE_HIST: 'OHNE_HIST' as HistoryMode,
    OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN: 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' as HistoryMode,
    MIT_HIST: 'MIT_HIST' as HistoryMode
  };
}
